import { useMutation } from '@tanstack/react-query';

import { useIamApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';

import type { AxiosError } from 'axios';
import type { UseMutationOptions } from '@tanstack/react-query';
import type { ResponseCloudUser } from '../api';
import type { UpdateUserDetailInfoReqParams } from '../constants';

type PatchUserDetailInfoOptions = UseMutationOptions<
  ResponseCloudUser,
  AxiosError,
  UpdateUserDetailInfoReqParams
>;

/**
 * 유저 정보(언어, 닉네임, 이름)를 변경하는 훅입니다.
 * @description
 * - react-query로 mutate를 제공합니다.
 */
const usePatchUserDetailInfo = (options?: PatchUserDetailInfoOptions) => {
  const { updateUserDetailInfo } = useIamApiInstance();
  const mutation = async (params: UpdateUserDetailInfoReqParams) => {
    const response = await updateUserDetailInfo(params);

    return response;
  };

  return useMutation({
    mutationKey: [HOST_QUERY_KEY.UPDATE_IAM_USER_DETAIL_INFO],
    mutationFn: mutation,
    onSuccess: () => {
      window.location.reload();
    },
    ...options,
  });
};

export default usePatchUserDetailInfo;
